<template>
    <h2 class="font-semibold uppercase text-primary-400"><slot /></h2>
</template>
